import { render, staticRenderFns } from "./PersonImport.vue?vue&type=template&id=29b036e0&scoped=true&"
import script from "./PersonImport.vue?vue&type=script&lang=js&"
export * from "./PersonImport.vue?vue&type=script&lang=js&"
import style0 from "./PersonImport.vue?vue&type=style&index=0&id=29b036e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b036e0",
  null
  
)

export default component.exports